import React from 'react';
import clsx from 'clsx';

export default function StatisticsCard({ children }) {
  return (
    <div className={clsx('border-b border-r border-gray-100 p-4 py-8')}>
      {children}
    </div>
  );
}
